<template>
  <div class="cancellation-terms">
    <div class="cancellation-term" v-for="(term, index) in cancelationTerms" :key="index">{{ term }}</div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
import { LANGUAGE_RU } from "@/util/enumTypes";
import util from "@/util/util";

export default {
  name: "service-cancellation-terms",
  props: {
    cancelationPolicy: Object,
    terms: Array
  },
  computed: {
    ...mapState({
      language: state => state.SettingStorage.language
    }),
    cancelationTerms() {
      if (this.cancelationPolicy) {
        return this.transformPolicyToTerms(this.cancelationPolicy);
      }

      if (this.terms && this.terms.length) {
        return this.terms;
      }

      return [];
    },
    dateFormat() {
      return this.language === LANGUAGE_RU ? "DD.MM.YYYY HH:mm" : "DD MMMM YYYY H:mm A";
    }
  },
  methods: {
    transformPolicyToTerms(policy) {
      if (!policy) {
        return [];
      }

      return policy.periods.map(this.mapPolicyPeriodToTerm);
    },

    mapPolicyPeriodToTerm(period) {
      const { startAtMsk, endAtMsk, amount } = period;

      if (amount === 0) {
        return this.$t("cancellation_made_before_charge_free", {
          beforeDate: this.formatDate(endAtMsk)
        });
      }

      if (startAtMsk && endAtMsk) {
        return this.$t("cancellation_made_between_charge", {
          afterDate: this.formatDate(startAtMsk),
          beforeDate: this.formatDate(endAtMsk),
          charge: this.formatPrice(amount)
        });
      }

      if (startAtMsk && !endAtMsk) {
        return this.$t("cancellation_made_after_charge", {
          afterDate: this.formatDate(startAtMsk),
          charge: this.formatPrice(amount)
        });
      }

      return "";
    },

    formatDate(date) {
      return moment(date).format(this.dateFormat);
    },

    formatPrice(price) {
      return `${util.formatMoney(price)}${this.$store.getters.SignCurrencyText}`;
    }
  }
};
</script>

<style>
.cancellation-term {
  word-break: normal;
  text-align: left;
  padding: .2rem 0;
}
</style>
